import * as React from "react";
import RadioButton from "../../../../generic/radioButton";
import TocDropdown from "../../../../generic/tocDropdown";
import FtConfirmBtn from "../../ftConfirmBtn";
import DeviceContext from "../../../../service/indentifyDevice";
import { Idevice } from "../../../../types/device";
import FtEdelBnkDtl from "./ftEdelBnkDtl";
import {
  AFtAddfundIn,
  AFTPayInUPIIntentStatus,
} from "../../../../service/fundTransfer/fundTransferApiService";
import { IPayIn } from "../../ftInterfaces";
import {
  IftPayInBankListDetails,
  IPayInLedger,
  IftPayInBankDetails,
  IPayinUPIDet,
  IErrorHandler,
} from "../../../../types/components/fundTransfer/ftTypes";
import { useHistory } from "react-router-dom";
import { EdLinkButton } from "../../../../generic/edButton";
import indexer, { IListObj } from "../../../../types/genericTypes";
import { FtInpField } from "../../generic/ftInpField";
import { ftFormValidate } from "./../../generic/ftFormValidation";
import { ftHelpDetails, FTRegex } from "../../ftConstants";

export interface IFtEquityFormProps {
  data: IftPayInBankListDetails;
  totalLim: string;
}

const FtEquityForm: React.FC<IFtEquityFormProps> = (props) => {
  const history = useHistory();

  const UPImaxAmount = 1000000;
  // list of banks linked to the trading account
  const banksList: Array<IListObj> = props.data.bnkAcs.map(
    (d: IftPayInBankDetails, index: number) => ({
      value: index,
      display: d.bnkName + " - " + d.bnkAccNo,
      primary: d.isPrimary,
    })
  );

  const paymodes: Array<string> = ["IB", "UPI", "INTENT", "QR", "EC"];
  //list of upi id's linked with the banks
  // const upiList: Array<IListObj> = props.data.upis.map((d: IPayinUPIDet, index: number) => ({ value: index, display: d.upi }));

  //type of device tablet/mobile/desktop
  const handleDevice: Idevice = DeviceContext();

  //find android device
  const isAndroidMobile: boolean =
    handleDevice.isMobile && navigator.userAgent.match(/Android/i)
      ? true
      : false;
  const primaryBank = props.data.bnkAcs.find((bnk) => {
    return bnk.isPrimary === true;
  });

  //form field values
  const [userInput, setUserInput] = React.useState<{
    amount: string | number;
    ledger: string;
    bank: IftPayInBankDetails | null;
    mode: string;
    upi: string;
    selectedUPIObj: IPayinUPIDet | null;
    intentDetails: {
      url: string;
      tr: string;
    };
  }>({
    amount: "",
    ledger: props.data.ldgrs!.length > 0 ? props.data.ldgrs![0].ldgrNm : "",
    bank: props.data.bnkAcs.length > 0 ? primaryBank || null : null, //select always a primary bank -> first one
    mode: selectlastPayMode(props.data.bnkAcs[0]),
    upi: "",
    selectedUPIObj: null,
    intentDetails: {
      url: "",
      tr: "",
    },
  });

  const amountErrMsgs: indexer = {
    min: "Minimum transfer amount is Rs.1",
    max:
      userInput.mode === "IB"
        ? undefined
        : "You can only use Net Banking for amount exceeding Rupees 1 Lakh",
  };

  const upiErrMsgs: indexer = {
    regEx: "UPI ID should be in the format name@bankname.",
  };

  //callback interval for fetching upi intent transaction status
  let pgCallbackInt: any = "";

  const [isFormSubmitted, setIsFormSubmitted] = React.useState(true);

  const isFormValid = React.useRef<boolean>();

  //select the last paymode by default
  function selectlastPayMode(bank: IftPayInBankDetails) {
    let paymode: string = "";

    if (bank.lstPayMode) {
      if (bank.lstPayMode === 0 && bank.fndTrsAvl) {
        //net banking
        paymode = paymodes[0];
      } else if (
        ((bank.upiAvl || bank.upiintent) && bank.lstPayMode === 1) ||
        (bank.lstPayMode === 2 && handleDevice.isMobile)
      ) {
        //if last paymode(2) is UPI QR and On transaction is happening on mobile choose UPI intent:UPI paymode
        //intent:upi
        isAndroidMobile && bank.upiintent
          ? (paymode = paymodes[2])
          : bank.upiAvl
          ? (paymode = paymodes[1])
          : (paymode = "");
      } else if (bank.upiqr && bank.lstPayMode === 2) {
        //upi qr
        paymode = paymodes[3];
      }
    }
    if (!paymode) {
      if (bank.fndTrsAvl) {
        //net banking
        paymode = paymodes[0];
      } else if (bank.upiAvl || bank.upiintent) {
        //intent:upi
        isAndroidMobile && bank.upiintent
          ? (paymode = paymodes[2])
          : bank.upiAvl
          ? (paymode = paymodes[1])
          : (paymode = "");
      } else if (bank.upiqr && handleDevice.isDesktop) {
        //upi qr
        paymode = paymodes[3];
      } else {
        paymode = paymodes[4]; //ecollect
      }
    }

    return paymode;
  }

  function onRadioSelect(val: string | number) {
    // console.log(val);
  }

  //error state handlers
  const [pgAPIRes, setpgAPIRes] = React.useState<{
    errCd: string;
    errMsg: string;
    upiId: string;
  }>({ errCd: "", errMsg: "", upiId: "" });
  let validationstatus: IErrorHandler = {
    ErrorState: true,
    key: "required",
    name: "",
  };
  const [inpValidations, setInpValidations] = React.useState<{
    [x: string]: IErrorHandler;
  }>({
    amount: { ...validationstatus, name: "amount" },
    upi: { ...validationstatus, name: "upi" },
  });
  //form submission error handlers

  const [submitErr, setSubmitErr] = React.useState<{
    errMsg: string;
    errCd: string;
    actCd: string;
  }>({ errMsg: "", errCd: "", actCd: "" });

  function validatePayInFrom(resetErr: boolean, errStateFlag: boolean = false) {
    const payinForm = document.querySelector("#payInForm") as HTMLFormElement;
    let tempErrObj: { [x: string]: IErrorHandler } = inpValidations;

    for (let i = 0; i < payinForm.elements.length; i++) {
      const element: HTMLInputElement = payinForm.elements[
        i
      ] as HTMLInputElement;
      if (element.nodeName === "INPUT" && element.dataset.validation) {
        if (!resetErr) {
          validationstatus = ftFormValidate(element, errStateFlag);
          if (validationstatus.name) {
            tempErrObj = {
              ...tempErrObj,
              [validationstatus.name]: validationstatus,
            };
          }
        }
      }
    }

    setInpValidations(tempErrObj);
  }
  function onFormFieldChange(key: string, value: any) {
    setUserInput({ ...userInput, [key]: value });
    validatePayInFrom(false);
  }
  //payment mode change
  function onModeChange(mode: string) {
    setUserInput({ ...userInput, mode });
    //reset submit form error
    setSubmitErr({ errCd: "", errMsg: "", actCd: "" });
  }

  function HandleState(resp: any) {
    const statusURL =
      "/fund-transfer/add-funds/status?status=" + JSON.stringify(resp);
    history.push(statusURL);
  }
  function PingForIntentTransStat(res: any) {
    if (res.data) {
      HandleState(res.data);
      clearInterval(pgCallbackInt);
    }
  }

  function FtAddfundInRes(res: any) {
    if (res.data) {
      if (userInput.mode === "INTENT") {
        let splitUrl: Array<string> = res.data.url.split("&"),
          tr: string = "";

        for (var i = 0; i < splitUrl.length; i++) {
          if (splitUrl[i].indexOf("tr") >= 0) {
            tr = splitUrl[i].split("=")[1];
          }
        }
        setUserInput({
          ...userInput,
          intentDetails: { url: res.data.url, tr: tr },
        });
        setTimeout(() => {
          document.getElementById("triggerIntentClick")?.click();
        }, 350);
        pgCallbackInt = setInterval(() => {
          AFTPayInUPIIntentStatus(PingForIntentTransStat, tr);
        }, 15000);
        // console.log(pgCallbackInt);
        if (pgCallbackInt) {
          setTimeout(function () {
            clearInterval(pgCallbackInt);
            const timeOutURL =
              "/fund-transfer/add-funds/status?status=" +
              JSON.stringify({
                bankrefno: "",
                customrefno: "",
                accountno: userInput.bank?.bnkAccNo,
                amount: userInput.amount,
                status: 0,
                bankname: userInput.bank?.bnkName,
                ru: userInput.amount,
                upi: "",
                paymode: "INTENT",
                remarks: "Request Timed Out",
                createddate: "",
                serverTime: new Date(),
                bodMarginMessage: "",
              });
            history.push(timeOutURL);
          }, 300000);
        }
      } else {
        // history.push(res.data.url);
        window.location.href = res.data.url;
      }
    } else if (res.error) {
      setpgAPIRes({ ...res.error, upiId: userInput.upi });
      if (res.error.errCd === "ETRD00018") {
        setInpValidations({
          ...inpValidations,
          upi: { ...validationstatus, name: "upi", key: res.error.errMsg },
        });
      } else {
        setSubmitErr(res.error);
      }
    }
  }

  function submitForm(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    setIsFormSubmitted(true);
    //reset submit form error
    setSubmitErr({ errCd: "", errMsg: "", actCd: "" });
    if (userInput.bank) {
      const data: IPayIn = {
        brcName: userInput.bank.brcName,
        bnkCode: userInput.bank.bnkCode,
        amt: +userInput.amount,
        bnkAccNo: userInput.bank.bnkAccNo,
        bnkName: userInput.bank.bnkName,
        paymtMd: userInput.mode as string,
        upi: userInput.mode === "UPI" ? (userInput.upi as string) : "",
        isPrimUpi: false,
        ldgrNm: userInput.ledger as string,
      };
      AFtAddfundIn(FtAddfundInRes, data);
    }
  }
  function updateFormSubmit(upiErrorMode: IErrorHandler) {
    var paymode = userInput.mode
      ? userInput.mode.toLowerCase()
      : userInput.mode;
    if (
      paymode &&
      ((paymode === "upi" && inpValidations.upi.ErrorState === true) ||
        inpValidations.amount.ErrorState === true)
    ) {
      isFormValid.current = false;
    } else {
      isFormValid.current = true;
    }

    if (isFormValid.current && isFormValid.current === true) {
      setIsFormSubmitted(false);
    } else {
      setIsFormSubmitted(true);
    }
  }

  React.useEffect(() => {
    //default selection of upi ID
    //map matched UPI id's of each object to array of banks obj key upiList

    if (props.data.upis) {
      props.data.bnkAcs.map((val: IftPayInBankDetails, i: number) => {
        const matchUpi = props.data.upis.find((upiList) => {
          return upiList.bankaccountnumber === val.bnkAccNo;
        });

        // if (!props.data.bnkAcs[i].upiList) props.data.bnkAcs[i].upiList = [];

        if (matchUpi) {
          props.data.bnkAcs[i].upiList.push(matchUpi);
        }
        return true;
      });
    }
    // eslint-disable-next-line
  }, [props.data.bnkAcs]);

  React.useEffect(() => {
    //selecting upi id from the upiList if avaialble for the selected bank
    //which are likely happens when there is change in bank and pay mode
    let PrimaryUPiId: number | null = null;
    if (userInput.mode === "UPI" && userInput.bank?.upiList.length) {
      PrimaryUPiId =
        userInput.bank.upiList.findIndex((val: IPayinUPIDet) => {
          return val.isprimary;
        }) || 0;
    }
    setUserInput({
      ...userInput,
      upi:
        PrimaryUPiId !== null && userInput.bank
          ? userInput.bank.upiList[PrimaryUPiId].upi
          : "",
    });
    //upi Id validation

    const UpiErrState: IErrorHandler =
      PrimaryUPiId != null
        ? { ErrorState: false, key: "", name: "upi" }
        : { ErrorState: true, key: "required", name: "upi" };
    //temp inpValidations state - set value
    let tempInpValidation: { [x: string]: IErrorHandler } = {
      ...inpValidations,
      upi: UpiErrState,
    };

    //amount field validation
    if (userInput.amount) {
      const amtValidation = ftFormValidate(
        document.getElementsByName("amount")[0] as HTMLInputElement,
        true
      );
      tempInpValidation = {
        upi: UpiErrState,
        amount: amtValidation,
      };
    }
    //set state
    setInpValidations(tempInpValidation);

    ((userInput.bank && userInput.bank.bankid === -1) ||
      userInput.mode === "EC") &&
      setUserInput({ ...userInput, amount: "" });

    // eslint-disable-next-line
  }, [userInput.bank, userInput.mode]);

  React.useEffect(() => {
    updateFormSubmit(inpValidations.upi);
    // eslint-disable-next-line
  }, [inpValidations]);

  return (
    <>
      <form id="payInForm" name="payInForm" noValidate>
        <div
          className={
            "eq_form_fld " +
            (userInput.intentDetails.url && handleDevice.isMobile ? "hide" : "")
          }
        >
          <div className="form-field">
            <FtInpField
              value={userInput.amount}
              clsNm={
                "ft_payin_input amt_inp_lh " +
                ((userInput.bank && userInput.bank.bankid === -1) ||
                userInput.mode === "EC"
                  ? "disabled"
                  : "")
              }
              min={1}
              max={userInput.mode === "IB" ? undefined : UPImaxAmount}
              autoFocus={true}
              type={!handleDevice.isMobile ? "text" : "number"}
              showProxyField={true}
              vr="normal"
              ph="Eg: 10,000"
              name="amount"
              pattern={FTRegex.mobAmt}
              regEx={FTRegex.amt}
              validation={{
                min: 1,
                max: userInput.mode === "IB" ? undefined : UPImaxAmount,
                required: true,
              }}
              validationEvent="change"
              label="Enter Amount"
              info={amountErrMsgs[inpValidations["amount"].key]}
              error={amountErrMsgs}
              prefix="&#8377;"
              proxy_inp="proxy"
              validateOnChange={true}
              onChange={onFormFieldChange}
              maxlength={10}
            />
          </div>
          {/* user ledgers */}
          {props.data.ldgrs && props.data.ldgrs.length > 0 && (
            <div className="form-field">
              <label className="input-label">Select Ledger</label>
              <ul className="radio_wrap">
                {props.data.ldgrs.map((item: IPayInLedger) => (
                  <li
                    key={item.ldgrId}
                    className="list_Item"
                    onClick={() => onRadioSelect(item.ldgrId)}
                  >
                    <RadioButton
                      list={{
                        value: item.ldgrId,
                        display: item.ldgrNm,
                      }}
                      name="ledger"
                      selected={
                        props.data.ldgrs[
                          props.data.ldgrs.findIndex(
                            (val: IPayInLedger) =>
                              val.ldgrNm === userInput.ledger
                          )
                        ].ldgrId
                      }
                      onChange={() =>
                        setUserInput({ ...userInput, ledger: item.ldgrNm })
                      }
                      moduleName="fundTransfer"
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
          {/* user bank list  */}
          {props.data.bnkAcs.length > 0 && (
            <div className="form-field">
              <label className="input-label">Select Bank</label>
              <TocDropdown
                selectedValue={
                  userInput.bank ? props.data.bnkAcs.indexOf(userInput.bank) : 0
                }
                dropdownOptions={banksList ? banksList : []}
                onSelect={(value) => {
                  setUserInput({
                    ...userInput,
                    bank: props.data.bnkAcs[value as number],
                    mode: selectlastPayMode(props.data.bnkAcs[value as number]),
                  });
                }}
                showPrimary
                isSearchable={false}
              />
            </div>
          )}
          {/* paymodes start */}
          {props.data.bnkAcs && props.data.bnkAcs.length > 0 && (
            <>
              {userInput.bank &&
                userInput.bank.bankid !== -1 &&
                (userInput.bank.fndTrsAvl ||
                  userInput.bank.upiAvl ||
                  userInput.bank.upiintent ||
                  userInput.bank.upiqr) && (
                  <>
                    <div className="form-field">
                      <label className="input-label">Payment Mode</label>
                      <ul className="radio_wrap">
                        {/* internet banking */}
                        {userInput.bank && userInput.bank.fndTrsAvl ? (
                          <li className="list_Item">
                            <RadioButton
                              list={{
                                value: "IB",
                                display: "Net Banking",
                              }}
                              name="paymentMode"
                              selected={userInput.mode}
                              onChange={() => onModeChange("IB")}
                              moduleName="fundTransfer"
                            />
                          </li>
                        ) : (
                          userInput.bank &&
                          userInput.bank.upiAvl && (
                            <li className="list_Item">
                              <RadioButton
                                list={{
                                  value: "EC",
                                  display: "eCollect",
                                }}
                                name="paymentMode"
                                selected={userInput.mode}
                                onChange={() => onModeChange("EC")}
                                moduleName="fundTransfer"
                              />
                            </li>
                          )
                        )}
                        {/* show upi mode if avaialble and in android device if upi intent is not available */}
                        {!(
                          isAndroidMobile &&
                          userInput.bank &&
                          userInput.bank.upiintent
                        ) &&
                          userInput.bank &&
                          userInput.bank.upiAvl && (
                            <li className="list_Item">
                              <RadioButton
                                list={{
                                  value: "UPI",
                                  display: "UPI id",
                                }}
                                name="paymentMode"
                                selected={userInput.mode}
                                onChange={() => onModeChange("UPI")}
                                moduleName="fundTransfer"
                              />
                            </li>
                          )}
                        {/* intent mode only for android */}
                        {isAndroidMobile &&
                          userInput.bank &&
                          userInput.bank.upiintent && (
                            <li className="list_Item">
                              <RadioButton
                                list={{
                                  value: "INTENT",
                                  display: "UPI",
                                }}
                                name="paymentMode"
                                selected={userInput.mode}
                                onChange={() => onModeChange("INTENT")}
                                moduleName="fundTransfer"
                              />
                            </li>
                          )}
                        {/* QR mode only in desktop web */}

                        {!handleDevice.isMobile &&
                          userInput.bank &&
                          userInput.bank.upiqr && (
                            <li className="list_Item">
                              <RadioButton
                                list={{
                                  value: "QR",
                                  display: "UPI QR",
                                }}
                                name="paymentMode"
                                selected={userInput.mode}
                                onChange={() => onModeChange("QR")}
                                moduleName="fundTransfer"
                              />
                            </li>
                          )}
                      </ul>
                    </div>

                    {userInput.mode === "UPI" && (
                      <div
                        className={
                          "upiFormField form-field " +
                          (userInput.bank && userInput.bank.upiList.length
                            ? "flexIt"
                            : "pd-b50")
                        }
                      >
                        {userInput.bank && userInput.bank.upiList.length ? (
                          <>
                            <label className="input-label">Select UPI id</label>

                            <TocDropdown
                              selectedValue={
                                userInput.selectedUPIObj
                                  ? userInput.bank.upiList.indexOf(
                                      userInput.selectedUPIObj
                                    )
                                  : 0
                              }
                              dropdownOptions={userInput.bank.upiList.map(
                                (d: IPayinUPIDet, index: number) => ({
                                  value: index,
                                  display: d.upi,
                                  primary: d.isprimary,
                                })
                              )}
                              onSelect={(value) => {
                                if (userInput.bank) {
                                  setUserInput({
                                    ...userInput,
                                    upi: userInput.bank.upiList[value as number]
                                      .upi,
                                    selectedUPIObj:
                                      userInput.bank.upiList[value as number],
                                  });
                                }
                              }}
                              showPrimary
                              showClose
                              isSearchable={false}
                            />
                          </>
                        ) : (
                          <>
                            <FtInpField
                              value={userInput.upi}
                              clsNm="ft_payin_input upiField"
                              autoFocus={true}
                              type="text"
                              showProxyField={false}
                              vr="normal"
                              ph="Eg: andre.braugher@axisbank"
                              name="upi"
                              pattern={FTRegex.upi}
                              validationEvent="change"
                              validation={{
                                regEx: "^[-.a-zA-Z0-9_]+@{1}[A-Za-z0-9]+$",
                                required: true,
                              }}
                              label="Enter UPI id"
                              info={upiErrMsgs[inpValidations["upi"].key]}
                              error={upiErrMsgs}
                              proxy_inp="input"
                              validateOnChange={true}
                              onChange={onFormFieldChange}
                            />
                            {inpValidations.upi.key &&
                              userInput.upi === pgAPIRes.upiId &&
                              pgAPIRes &&
                              pgAPIRes.errCd === "ETRD00018" && (
                                <div className="formInpCont dBlock">
                                  <p className={`info mgL`} data-error={true}>
                                    {pgAPIRes.errMsg}
                                  </p>
                                </div>
                              )}
                          </>
                        )}
                      </div>
                    )}
                    {submitErr.errMsg && (
                      <div className="formInpCont dBlock mg-b20">
                        <p className={`info taCenter`} data-error={true}>
                          {submitErr.errMsg}
                        </p>
                      </div>
                    )}
                  </>
                )}
              {/* show edelweiss beneficiary details if net banking is not supported */}
              {props.data.bnkAcs &&
              ((userInput.bank &&
                !userInput.bank.fndTrsAvl &&
                userInput.mode === "EC") ||
                (userInput.bank && userInput.bank.bankid === -1)) ? (
                <FtEdelBnkDtl {...props.data.edelBnkDtl} />
              ) : (
                <>
                  <div className="confirm_btn_wrap mg-t10">
                    <FtConfirmBtn
                      onClick={submitForm}
                      errTxt={props.data.bodMsg}
                      disbaled={isFormSubmitted}
                    />
                    <a
                      href={userInput.intentDetails.url}
                      id="triggerIntentClick"
                      className="hiddenIntentLink hide"
                    >
                      Hidden
                    </a>
                  </div>
                  <div className="info_erap">
                    <p>
                      In case the bank account mentioned is incorrect; you are
                      requested to contact customer service. Write to{" "}
                      <a href={"mailto:" + ftHelpDetails.email}>
                        {ftHelpDetails.email}
                      </a>
                    </p>
                  </div>
                </>
              )}
            </>
          )}
        </div>
        {userInput.intentDetails.url && handleDevice.isMobile && (
          <div
            className="showOnIntentActive"
            style={{ minHeight: window.innerHeight }}
          >
            <div className="intentWrapper">
              <div className="bubbles">
                <i className="bubble bubble1"></i>
                <i className="bubble bubble2"></i>
                <i className="bubble bubble3"></i>
              </div>
              <p className="message">
                Awaiting approval of transfer request in the selected payment’s
                app
              </p>
              <EdLinkButton
                LinkHref={"/fund-transfer/history/eq/added"}
                value="Cancel"
                slim
                btnTyp="secondary"
                className="mg-t20"
              />
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default FtEquityForm;
